import { create } from 'zustand'
import { createStorage } from './storage'
import { devtools, persist } from 'zustand/middleware'

export interface ZugnummerStoreState {
  zugnummer: string
  setZugnummer: (zugnummer: string) => void
  clearZugnummer: () => void
}

const initialSettings = {
  zugnummer: ''
}

export const useZugnummerStore = create<ZugnummerStoreState>()(
  devtools(
    persist(
      (set) => ({
        zugnummer: initialSettings.zugnummer,
        setZugnummer: (zugnummer: string) => set({ zugnummer }),
        clearZugnummer: () => set({ zugnummer: '' })
      }),
      {
        name: 'zugnummer-storage',
        storage: createStorage(),
        version: 0
      }
    )
  )
)
